import { render, staticRenderFns } from "./MPCurrentMonthIndicator.vue?vue&type=template&id=583cc097&"
import script from "./MPCurrentMonthIndicator.vue?vue&type=script&lang=js&"
export * from "./MPCurrentMonthIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports